<template>
  <div class="vacant-card">
    <a href="#" class="stretched-link" @click.prevent="$emit('showModal')"></a>
    <div class="vacant-card-container d-flex flex-column justify-content-between align-items-start">
      <h3 class="ttl">{{content.title}}</h3>
      <div class="description-cont">
        <p class="description">{{cutText(content.textarea)}}</p>
        <p class="price">от {{content.text}} ₽</p>
      </div>
      <p class="link">
        Читать подробнее
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
        >
          <path d="M0 8V6H12L8 2L9 0L16 7L9 14L8 12L12 8H0Z" fill="white" />
        </svg>
      </p>
    </div>
  </div>
</template>

<script>
//const axios = require('axios');
export default {
  props: {
    content: Object
  },
  data() {
    return {};
  },
  methods: {
    cutText(value, symbolsCount = 100) {
      return value.length > symbolsCount
        ? value.slice(0, symbolsCount - 3) + "..."
        : value;
    }
  }
};
</script>

<style lang="scss">
.vacant-card {
  &:hover .vacant-card-container {
    background-position-x: 350px;

    .ttl {
      color: $activeColor;
    }

    .description-cont {
      .description {
        opacity: 1;
        transform: translateX(0);
      }

      .price {
        transform: translateX(120%);
      }
    }

    .link {
      color: $activeColor;

      svg {
        margin-left: 32px;

        path {
          fill: $activeColor;
        }
      }
    }
  }
  &-container {
    height: 245px;
    position: relative;
    background-color: #ffffff;
    background-origin: border-box;
    border-radius: 6px;
    padding: 30px 17px 22px 15px;
    overflow: hidden;
    background-image: url("~@/assets/img/vacant-card_bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    transition: all 0.5s ease-in-out;
    margin-bottom: 30px;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
      margin-bottom: 15px;
    }

    .ttl {
      font-weight: 800;
      font-size: 22px;
      line-height: 110%;
      color: #ffffff;
      transition: all 0.5s ease-in-out;
    }

    .description-cont {
      position: relative;

      .description {
        opacity: 0;
        font-size: 14px;
        line-height: 120%;
        color: $secondFontColor;
        position: relative;
        transform: translateX(-50%);
        transition: all 0.5s ease-in-out;
      }

      .price {
        position: absolute;
        top: 0;
        left: 0;
        font-weight: 500;
        font-size: 24px;
        line-height: 120%;
        color: #005da4;
        width: 100%;
        opacity: 1;
        transition: all 0.5s ease-in-out;
      }
    }

    .link {
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: #ffffff;
      transition: all 0.5s ease-in-out;

      svg {
        margin-left: 12px;
        transition: all 0.5s ease-in-out;

        path {
          transition: all 0.5s ease-in-out;
        }
      }
    }
  }
}
</style>

